import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import Select from "react-select";
import { ClearButton } from "../../app/common";

const SelectControl = props => {
  const {
    onBlur,
    valueLink,
    options = [],
    multiple,
    searchable,
    placeholder,
    closeMenuOnSelect,
    menuIsOpen,
    noOptionCustom = () => <div>No options</div>,
    onChangeCallback = () => { },
    disabled = false,
    failedValidation,
    canClear = false,
    selectAll = false,
  } = props;

  const originalOptions = Array.isArray(options) ? options : [];

  const ALL_VALUE = "all";
  const allOption = { label: "All", value: ALL_VALUE };

  // Always include "All" at top if selectAll && multiple
  const optionsWithAll =
    selectAll && multiple ? [allOption, ...originalOptions] : originalOptions;

  const optionsDict = _.keyBy(originalOptions, "value");
  const stateValue = valueLink.value;

  // Map selected values (exclude "all")
  let valueOption = "";
  if (multiple) {
    valueOption = Array.isArray(stateValue)
      ? stateValue.map(v => optionsDict[v]).filter(Boolean)
      : [];
  } else {
    valueOption = stateValue ? optionsDict[stateValue] : "";
  }

  const onChangeInternal = selectedOption => {
    if (multiple) {
      if (!selectedOption || selectedOption.length === 0) {
        valueLink.requestChange([]);
        onChangeCallback(onBlur);
        return;
      }

      const selectedValues = selectedOption.map(o => o?.value).filter(Boolean);

      if (selectedValues.includes(ALL_VALUE)) {
        // Replace selection with ALL real option values (excluding "all")
        const allValues = originalOptions.map(o => o.value);
        valueLink.requestChange(allValues);
        onChangeCallback(onBlur);
        return;
      }

      // Otherwise store normal values
      const valuesToStore = selectedValues.filter(v => v !== ALL_VALUE);
      valueLink.requestChange(valuesToStore);
      onChangeCallback(onBlur);
    } else {
      valueLink.requestChange(selectedOption ? selectedOption.value : "");
      onChangeCallback(onBlur);
    }
  };

  return (
    <div>
      <Select
        menuIsOpen={menuIsOpen}
        closeMenuOnSelect={closeMenuOnSelect}
        isMulti={multiple}
        value={valueOption}
        onChange={onChangeInternal}
        options={optionsWithAll}
        isClearable={canClear}
        isSearchable={searchable}
        isDisabled={disabled}
        placeholder={placeholder}
        noOptionsMessage={noOptionCustom}
        classNamePrefix={`custom-select`}
        className={`${failedValidation && failedValidation.message ? "has-error" : ""}`}
      />
      {multiple && selectAll && Array.isArray(valueLink.value) && valueLink.value.length > 0 && (
        <ClearButton style={{
          right: "0px",
        }} onClick={() => {
          valueLink.requestChange([]);
          onChangeCallback(onBlur);
        }} />
      )}

    </div>
  );
};

SelectControl.propTypes = {
  onBlur: PropTypes.func.isRequired,
  valueLink: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  multiple: PropTypes.bool,
  placeholder: PropTypes.string,
  selectAll: PropTypes.bool,
};

SelectControl.defaultProps = {
  multiple: false,
  placeholder: "Select Values",
  selectAll: false,
};

export default SelectControl;
